<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">Q-Studio</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">Q-Studio {{ $t("qstudio.title") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            {{ $t("qstudio.titleP1_1") }}<a href="//www.pwmat.com/pwm-gui-introduce">Q-Flow</a>
            {{ $t("qstudio.titleP1_2") }}<a href="https://mcloud.lonxun.com">{{ $t("qflow.titleP1_3a") }}</a>
            {{ $t("qstudio.titleP1_3") }}
          </p>
          <div class="mstation-introduce-content-img">
            <img
              class="mstation-introduce-content-img-png"
              src="../../assets/produce/QStudio/qstudio-function.png"
            />
          </div>
          <p class="pwmat-introduce-content-info-text">
            {{ $t("qstudio.feature1") }}
          </p>
          <p class="pwmat-introduce-content-info-text">
            {{ $t("qstudio.feature2") }}
          </p>
          <p class="pwmat-introduce-content-info-text">
            {{ $t("qstudio.feature3") }}
          </p>
          <p class="pwmat-introduce-content-info-text">
            {{ $t("qstudio.feature4") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/1访问qs20220419_155517.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">
            {{ $t("qstudio.step1") }}
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/2建立晶格20220420_100652.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step2") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/3修改晶格20220420_101120.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step3") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/4添加原子20220420_100800.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step4") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/5建立超胞20220420_100840.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step5") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/6移动原子20220420_100913.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step6") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/7修改元素20220420_101003.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step7") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/8固定原子20220420_101156.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step8") }}</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/9建组20220420_101035.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">{{ $t("qstudio.step9") }}</p>
        </div>
        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">{{ $t("qstudio.download") }}</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toMSTATIONDownload"
          >
          {{ $t("qstudio.download1") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toModuleDownload"
          >
          {{ $t("qstudio.download2") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toManual"
          >
          {{ $t("qstudio.download3") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toPotentialDownload"
          >
          {{ $t("qstudio.download4") }}
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='http://mcloud-doc.lonxun.com'"
          >
          {{ $t("qstudio.download5") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-introduce-content-info-img-text {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-top: 6px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.mstation-introduce-content-img {
  text-align: center;
}
.mstation-introduce-content-img-png {
  margin-top: 20px;
  width: 100%;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
